import React, { Component } from 'react'
import { Link } from 'react-router-dom'
class Error extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                <div class="page-wrap flex-row align-items-center">
                    <div className="error-inner d-flex flex-column text-center justify-content-center">
                        <span class="display-1 d-block">404</span>
                        <div class="mb-4 lead">The page you are looking for was not found.</div>
                        <Link to={'/'} class="btn btn-link">Back to Home</Link>
                    </div>
                </div>
            </>
        )
    }
}

export default Error